import { render, staticRenderFns } from "./LiefengContent2.vue?vue&type=template&id=46483546&scoped=true&"
import script from "./LiefengContent2.vue?vue&type=script&lang=js&"
export * from "./LiefengContent2.vue?vue&type=script&lang=js&"
import style0 from "./LiefengContent2.vue?vue&type=style&index=0&id=46483546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46483546",
  null
  
)

export default component.exports